"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
const seam_1 = require("services/master-data/seam");
const area_1 = require("services/master-data/area");
const brand_1 = require("services/master-data/brand");
const seam_types_1 = require("./seam.types");
const getDataGrid = (dataStates) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const response = yield (0, seam_1._getMasterSeam)(dataStates);
    if (response.isError) {
        const payload = {
            errorCode: response.errorCode,
            errorMessage: response.errorMessage,
            isError: true
        };
        dispatch({ type: seam_types_1.seamTypes.SET_ERROR, payload });
    }
    else {
        const payload = {
            count: response.countData,
            dataGrid: response.isError
                ? []
                : response.data.map((item) => {
                    return Object.assign(Object.assign({}, item), { created_date: new Date(item.created_date), modified_date: new Date(item.modified_date) });
                }),
        };
        dispatch({ type: seam_types_1.seamTypes.SET_DATA_GRID, payload });
    }
});
const getDetail = () => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const responseArea = yield (0, area_1._getMasterArea)(dataStates);
    const responseBrand = yield (0, brand_1._getBrandData)(dataStates);
    const dataArea = responseArea.data;
    const dataBrand = responseBrand.data;
    dispatch({
        type: seam_types_1.seamTypes.GET_DETAIL, payload: {
            dataArea,
            dataBrand
        }
    });
});
const dataStates = {
    filterable: true,
    sortable: true,
    reorderable: false,
    scrollable: 'scrollable',
    skip: 0,
    take: 10000000,
    total: 0,
    filter: {
        'logic': 'and',
        'filters': [
            { 'field': 'is_active', 'operator': 'eq', 'value': true }
        ]
    },
};
const onDataStateChange = (dataStates) => (dispatch) => {
    const payload = {
        dataStates,
    };
    dispatch({ type: seam_types_1.seamTypes.ON_PAGE_CHANGE, payload });
};
const onClickMutation = (payload) => (dispatch) => {
    dispatch({ type: seam_types_1.seamTypes.ON_MUTATION_CLICK, payload });
};
const onSaveDataItem = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    var _a, _b, _c, _d, _e, _f;
    let { mutationMode } = payload;
    const response = mutationMode == 'add'
        ? yield (0, seam_1._createSeam)({
            seam: (_a = payload.dataItem) === null || _a === void 0 ? void 0 : _a.seam,
            is_active: (_c = (_b = payload.dataItem) === null || _b === void 0 ? void 0 : _b.is_active) === null || _c === void 0 ? void 0 : _c.value,
            id_area: payload.dataItem.area.id,
            id_brand: payload.dataItem.brand.id
        })
        : yield (0, seam_1._editSeam)({
            id: payload.dataItem.id,
            seam: (_d = payload.dataItem) === null || _d === void 0 ? void 0 : _d.seam,
            is_active: (_f = (_e = payload.dataItem) === null || _e === void 0 ? void 0 : _e.is_active) === null || _f === void 0 ? void 0 : _f.value,
            modified_date: new Date(),
            id_area: payload.dataItem.area.id,
            id_brand: payload.dataItem.brand.id
        });
    const isFailed = response.isError;
    mutationMode = !response.isError ? 'success' : mutationMode;
    const messageError = response.errorMessage;
    if (!isFailed) {
        dispatch({ type: seam_types_1.seamTypes.ON_SAVE_DATAITEM, payload: Object.assign(Object.assign({}, payload), { isFailed, mutationMode, messageError }) });
    }
    else {
        dispatch({ type: seam_types_1.seamTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: response.isError, errorCode: response.errorCode, errorMessage: response.errorMessage }) });
    }
});
const onDelete = (payload) => (dispatch) => __awaiter(void 0, void 0, void 0, function* () {
    const res = yield (0, seam_1._deleteSeam)({ id: payload.dataItem.id });
    if (!res.isError) {
        dispatch({ type: seam_types_1.seamTypes.ON_DELETE, payload: Object.assign({}, payload) });
    }
    else {
        dispatch({ type: seam_types_1.seamTypes.SET_ERROR, payload: Object.assign(Object.assign({}, payload), { isError: res.isError, errorCode: res.errorCode, errorMessage: res.errorMessage }) });
    }
});
const onFilterChange = (payload) => (dispatch) => {
    dispatch({ type: seam_types_1.seamTypes.ON_FILTER_CHANGE, payload });
};
const onSortChange = (payload) => (dispatch) => {
    dispatch({ type: seam_types_1.seamTypes.ON_SORT_CHANGE, payload });
};
const toggleError = payload => dispatch => {
    dispatch({ type: seam_types_1.seamTypes.SET_ERROR, payload });
};
const onLoading = () => dispatch => {
    dispatch({ type: seam_types_1.seamTypes.SET_LOADING, payload: true });
};
exports.default = {
    getDataGrid,
    onDataStateChange,
    onClickMutation,
    onSaveDataItem,
    onDelete,
    onFilterChange,
    onSortChange,
    toggleError,
    onLoading,
    getDetail
};
